import BaseApi from './BaseApi';

/**
 * 通知メール受信確認のためテストメールを送信するAPI
 */
class SendNoticeTestMailApi extends BaseApi {
  /** @param noticeMail  */
  async send(noticeMail: string[]) {
    return await this.execute('sendNoticeTestMailApi', {
      method: 'POST',
      body: { noticeMail }
    }).then(({ status }) => status === 1);
  }
}

export default SendNoticeTestMailApi;
